<app-langding-page-nav-bar></app-langding-page-nav-bar>

<div class="content">

  <div style="margin-top: 80px;">
    <label class="control-label padding-top-0 margin-bottom-5 margin-top-5">Community Profile
      Creation</label>
    <div class="row">
      <div class="col-sm-9">
        <!-- <p>
          Fields marked with <span style="color: red;">*</span> are mandatory!
        </p> -->

        <!-- <h2 class="font-light m-b-xs">
                  Community Profile Creation
              </h2> -->



        <form [formGroup]="communityForm" class="app-form form-horizontal">
          <div class="hpanel">
            <div class="panel-heading hbuilt">
              <!-- class="control-label padding-top-0 margin-bottom-5 margin-top-5" -->

              <label>Community Details</label>
            </div>
            <div class="panel-body">
              <div class="form-group row">
                <label for="communityName" class="col-sm-3 control-label required-field font-bold">Community
                  Name</label>
                <div class="col-sm-8">
                  <input id="community_name_input" type="text" class="form-control input-sm" placeholder="Community Name"
                    formControlName="communityName" trim="blur" />
                  <div *ngIf="submit && communityControl.communityName.invalid || communityControl.communityName.invalid &&
                   (communityControl.communityName.dirty || communityControl.communityName.touched)" class="error-msg">
                    <div *ngIf="communityControl.communityName.errors.required"> Community Name is required</div>
                    <div *ngIf="communityControl.communityName.errors.maxlength"> Please enter below 100 characters
                    </div>

                    <!-- <div *ngIf="communityControl.communityName.errors.pattern">Please avoid unwanted spaces
                    </div> -->
                  </div>

                </div>
              </div>
              <div class="form-group row">
                <label for="tagLine" class="col-sm-3 control-label font-bold">Tag Line</label>
                <div class="col-sm-8">
                  <input id="community_tagline_input" type="text" class="form-control input-sm" placeholder="Tag Line" trim="blur"
                    formControlName="tagLine" />
                  <div *ngIf="communityControl.tagLine.invalid" class="error-msg">
                    <div *ngIf="communityControl.tagLine.errors.maxlength"> Please enter below 140 characters</div>
                  </div>
                </div>
              </div>

              <div class="form-group row">
                <label for="communityType" class="col-sm-3 control-label font-bold">Community Type</label>
                <div class="col-sm-8">
                  <div class="row padding-top-5">
                    <div class="col-sm-4">
                      <!-- <label class="container2 font-light">Private
                                <input type="radio" name="communityType" formControlName="communityType"
                                 id="cv" [value]="true">
                                 <span class="checkmark"></span>
                                </label> -->

                      <div class="custom-checkbox margin-top-5">
                        <label class="checkbox-label font-normal" style="text-align: center;font-size: 14px;"> Private
                          <input type="radio" [value]="true" formControlName="communityType" name="communityType">
                          <span title="Check Working Days" class="checkmark"></span>
                        </label>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <!-- <label class="container2 font-light">Public
                                <input type="radio" name="communityType" formControlName="communityType"
                                 id="dsf34" [value]="false">
                                 <span class="checkmark"></span>
                                </label> -->

                      <div class="custom-checkbox margin-top-5">
                        <label class="checkbox-label font-normal" style="text-align: center;font-size: 14px;"> Public
                          <input type="radio" [value]="false" formControlName="communityType" name="communityType">
                          <span title="Check Working Days" class="checkmark"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group row">
                <label for="businessLogo" class="col-sm-3 control-label font-bold">Community Logo</label>
                <div class="col-sm-8">
                  <ng-template #template>
                    <!-- <button type="button" style="font-size: 31px;padding-right: 17px;padding-top: 7px;"
                      class="close pull-right" aria-label="Close" (click)="modalclose()">
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <h5 style="margin: 10px 10px 10px 10px; padding-top: 10px;">Community Logo</h5>
                    <hr> -->

                    <div class="modal-content">

                      <div style="padding: 14px 14px !important;">
                        <label>Community Logo</label>
                        <button type="button" class="close pull-right" aria-label="Close" (click)="modalclose()">
                          <span style="font-size: 2.5rem;font-weight: 400;" aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <hr style="margin: 0px !important; padding: 0px !important">
                      <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true"
                        [aspectRatio]="2 / 2" format="jpeg" (imageCropped)="imageCropped($event)"
                        (cropperReady)="cropperReady()" (loadImageFailed)="loadImageFailed()"></image-cropper>

                      <div class="modal-footer" style="margin-bottom: 20px;border-radius: 5px;">
                        <button class="btn primary-btn" (click)="imageLoaded()">Apply</button>
                      </div>
                    </div>
                    <!-- <div class="modal-body"> -->
                    <!-- </div> -->
                  </ng-template>

                  <input type="file" formControlName="banner" accept="image/*" id="profileimage" class="form-control"
                    (change)="fileChangeEvent($event,template)" #myFileInput (click)="myFileInput.value=null" />
                </div>
              </div>

              <div class="form-group row">
                <label for="tags" class="col-sm-3 control-label font-bold"> #Tags</label>
                <div class="col-sm-8">
                  <!-- <tag-input class=" tag-align input-sm"   formControlName="tags"
                       [maxItems]='3'
                        [editable]='true'
                        [modelAsStrings]='true'
                        [placeholder]="placeholder"
                        [secondaryPlaceholder]="secondaryPlaceholder"
                        ></tag-input> -->
                  <ng-select [isOpen]="false" [addTag]="true" [multiple]="true" maxSelectedItems="3"
                    addTagText="Add #Tag:" bindValue="label" [closeOnSelect]="true" [hideSelected]="false"
                    placeholder="Options to add 3 #tags only" [(ngModel)]="tagSelectedItems" formControlName="tags">
                    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                      <div class="ng-select-checkbox-label">
                        <span class="ng-select-checkmark" [class.checked]="item$.selected"></span>
                        <span class="ng-select-checkbox-text">{{item}}</span>
                      </div>
                    </ng-template>
                  </ng-select>
                  <label><small>Press enter to give multiple #Tags </small></label>

                </div>

              </div>
            </div>
          </div>

          <div class="hpanel">
            <div class="panel-heading hbuilt">
              <!-- class="control-label padding-top-0 margin-bottom-5 margin-top-5" -->
              <label>Brief about your Community</label>

            </div>

            <div class="panel-body">
              <div class="row">
                <div class="form-group">
                  <div class="col-sm-11" style=" margin-left: 20px;">
                    <div formControlName="aboutCommunity" id="aboutCommunity" [ngxSummernote]="config">
                    </div>
                    <div style="color: #c3002f;" *ngIf="communityForm.controls.aboutCommunity.invalid">
                      <div *ngIf="communityForm.controls.aboutCommunity.errors.maxlength">
                        Maximum characters allowed is 1000
                      </div>
                    </div>
                    <div class="col-sm-6">
                    </div>
                    <div class="col-sm-6 text-right">
                      <label><small><span *ngIf="remainingAboutCount===undefined">1000 </span> <span *ngIf="remainingAboutCount!==undefined && remainingAboutCount > 0">{{remainingAboutCount + " "}}</span>
                        <span *ngIf="remainingAboutCount <= 0">0 {{" "}}</span>
                        characters remaining</small></label>
                    </div>
                    <!-- <label><small>Maximum characters allowed is 1000</small></label> -->

                  </div>

                </div>
              </div>
            </div>
          </div>


          <div class="hpanel">
            <div class="panel-heading hbuilt">

              <!-- class="control-label padding-top-0 margin-bottom-5 margin-top-5" -->
              <label>Community Guidelines</label>
            </div>

            <div class="panel-body">
              <div class="form-group row">
                <div class="form-group">
                  <div class="col-sm-11" style=" margin-left: 20px;">
                    <div formControlName="communityGuidelines" id="communityGuidelines" [ngxSummernote]="config1">
                    </div>
                    <div style="color: #c3002f;" *ngIf="communityForm.controls.communityGuidelines.invalid">
                      <div *ngIf="communityForm.controls.communityGuidelines.errors.maxlength">
                        Maximum characters allowed is 4000
                      </div>
                    </div>
                    <div class="col-sm-6">
                    </div>
                    <div class="col-sm-6 text-right">
                      <label><small><span *ngIf="remainingGuidelinesCount===undefined">4000 </span> <span *ngIf="remainingGuidelinesCount!==undefined && remainingGuidelinesCount > 0">{{remainingGuidelinesCount + " "}}</span>
                        <span *ngIf="remainingGuidelinesCount <= 0">0 {{" "}}</span>
                        characters remaining</small></label>
                    </div>
                    <!-- <label><small>Maximum characters allowed is 4000</small></label> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="text-right">

            <button type="button" [routerLink]="['/landingPage']" routerLinkActive="router-link-active"
              class="btn btn-default" (click)="clearformData()">Cancel</button>
            <button style="margin-left:2%;" type="button" class="btn primary-btn" (click)="save()">Create
              Community</button>
          </div>
        </form>
      </div>
      <div class="col-sm-3 sidebar" [ngClass]="{'haltThere': stopThere}">
        <!-- <app-common-widget [page]="'COMMUNITY_CREATE_PAGE'" [inputData]="'COMMUNITY'"></app-common-widget> -->
        <!-- Component removed - app-community-profile-complete not found -->
      </div>
    </div>
  </div>
</div>
